// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jjpLc","fullView":"styles_fullView__3ML0v"};